module.exports = __webpack_public_path__ + "img/back_middle_building_designs 1.070124e2.png";